import React from 'react'
import SlugTable from '../utils/SlugTable'

const Slugs = () => <SlugTable mode="all" />

export default Slugs